import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { EmailApiService } from '@core/services/application/email/email-api.service';
import { ApiResponse } from '@models/api-response';
import { EmailSubscriptionModel } from '@models/email/email-subscription.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription, map } from 'rxjs';

@Component({
  selector: 'zbp-email-notifications-modal',
  templateUrl: './email-notifications-modal.component.html',
  styleUrls: ['./email-notifications-modal.component.scss'],
  standalone: false
})
export class EmailNotificationsModalComponent implements OnDestroy {

  emailPrefsForm = new FormGroup({
    emailAddress: new FormControl(''),
    oneRosterFiles: new FormControl(true),
    oneRosterErrors: new FormControl(true),
    turnOffDashboard: new FormControl(true)
  });

  private subscription: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private emailService: EmailApiService,
    private toastr: ToastrService,
  ) {}

  /**
   * Saves the record
   */
  submitForm(): void {
    this.subscription?.unsubscribe();

    const request: EmailSubscriptionModel = {
      emailAddress: this.emailPrefsForm.get('emailAddress').value,
      initialOneRosterFilePlacement: this.emailPrefsForm.get('oneRosterFiles').value,
      oneRosterCriticalErrors: this.emailPrefsForm.get('oneRosterErrors').value,
      integrationsShutOffRequest: this.emailPrefsForm.get('turnOffDashboard').value,
    };

    this.subscription = this.emailService.saveNotificationEmail(request).pipe(
      map((response: ApiResponse<EmailSubscriptionModel>) => {
        if (response.success) {
          this.toastr.success('Email address changes saved successfully', 'Success');
          this.dismiss();
          return response.response;
        }
        throw new Error(response.messages[0]);
      }),
    ).subscribe();
  }

  /**
   * Closes the modal
   */
  dismiss(): void {
    this.activeModal.dismiss();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
